import { render, staticRenderFns } from "./NonNilCorrCustomerDetail.vue?vue&type=template&id=0957cf47&scoped=true"
import script from "./NonNilCorrCustomerDetail.vue?vue&type=script&lang=js"
export * from "./NonNilCorrCustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./NonNilCorrCustomerDetail.vue?vue&type=style&index=0&id=0957cf47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0957cf47",
  null
  
)

export default component.exports